import { useState } from 'react';
import Form, { Input, DatePicker } from '../../../components/Form'
import {Link, Redirect, useParams} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import Forbidden from '../../Forbidden';
import Updates from '../../../components/Updates';
import FileUpload from '../../../components/FileUpload';

function EditStrip({nsp}) {
	const {t, user, site} = nsp;
	const [redirect, setRedirect] = useState(false);
	const {id, uid} = useParams();
	const [uploadedFile, setUploadedFile] = useState([]);

	let comic;
	if (user.comics && Array.isArray(user.comics)) {
		const checkUserArray = user.comics.filter((el) => el.id == id);
		if (checkUserArray.length) {
			comic = checkUserArray[0];
		}
	}

	const onSuccess = (data) => {
		setRedirect(true);
	}

	if (!comic) {
		return <Forbidden nsp={nsp} />
	}

	if (redirect) {
		return <Redirect push to={`/n/${t['/ME']}/${t['/COMICS']}/${id}/${t['/STRIPS']}/`} />
	}

	return (
		<div>
			<Helmet>
				<title>{`${t['EDIT_STRIP']} :: ${t['PAGE_TITLE']}`}</title>
			</Helmet>
			<nav className="breadcrumbs" aria-label={t['BREADCRUMBS']}>
				<Link to="/">{t['PAGE_TITLE']}</Link>
				{" > "}
				<Link to={t['LINK_MY_PAGE']}>{t['MY_PAGE']}</Link>
				{" > "}
				<Link to={t['LINK_MY_COMICS']}>{t['MY_COMICS']}</Link>
				{" > "}
				<Link to={t['LINK_DASHBOARD_COMIC'].replace('{comic}', comic.id)}>{comic.name}</Link>
				{" > "}
				<Link to={`/n/${t['/ME']}/${t['/COMICS']}/${id}/${t['/STRIPS']}/`}>{t['ALL_STRIPS']}</Link>
				{" > "}
			</nav>
			<h2>{t['EDIT_STRIP']}</h2>
			<Form
				formName="newBlogPost"
				action={`${site.api}updates/${id}/${uid}/`}
				submitText={t['UPDATE_STRIP_METADATA']}
				onSuccess={onSuccess}
				mode="edit"
				nsp={nsp}
			>
				<h3>{t['STRIP_METADATA']}</h3>
				<Input type="hidden" name="updtype" value="b" />
				<Input type="text" name="title" label={t['TITLE']} />
				<Input type="editor" name="text" label={t['DESCRIPTION']} />
				<DatePicker name="pubtime" label={t['PUBLISH_TIME']} />
				<Input type="select" name="published" label={t['VISIBILITY']}>
					<option value="0">{t['DRAFT']}</option>
					<option value="1">{t['PUBLISHED']}</option>
				</Input>
			</Form>
			<h3>{t['REPLACE_STRIP']}</h3>
			<section className="replace-strip">
				<div className="upload-form">
					<FileUpload nsp={nsp} comic={id} strip={uid} elementArray={uploadedFile} setElementArray={setUploadedFile} type="c" />
				</div>
				<div className="strip-thumbnail">
					<Updates nsp={nsp} comic={id} type="c" count="1" updateId={uid} fields={['thumb']} context="edit" key={uploadedFile} />
				</div>
			</section>
		</div>
	)
}

export default EditStrip;